import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.onClick = (event) => this.startCheckout(event)
    this.element.querySelectorAll("[data-amount]").forEach((button) => {
      button.removeEventListener("click", this.onClick)
      button.addEventListener("click", this.onClick)
    })
  }

  disconnect() {
    if (!this.onClick) return

    this.element.querySelectorAll("[data-amount]").forEach((button) => {
      button.removeEventListener("click", this.onClick)
    })
  }

  async startCheckout(event) {
    const button = event.currentTarget
    const amount = button.getAttribute("data-amount")
    const initData = button.getAttribute("data-init-data") || ""
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const formData = new FormData()
    formData.append("amount", amount)
    formData.append("init_data", initData)
    if (csrfToken) formData.append("authenticity_token", csrfToken)

    const headers = csrfToken ? { "X-CSRF-Token": csrfToken } : {}
    const response = await fetch(this.urlValue, { method: "POST", body: formData, headers })
    if (!response.ok) return

    let json
    try {
      json = await response.json()
    } catch {
      return
    }
    if (json.url && window.Telegram?.WebApp?.openLink) {
      window.Telegram.WebApp.openLink(json.url)
    } else if (json.url) {
      window.location.href = json.url
    }
  }
}
